import {Observable} from 'rxjs';
import {distinctUntilChanged, filter, map, share} from 'rxjs/operators';

import SyntheticMediaEventType   from '../../../../Solutions/Shared/Constants/SyntheticMediaEventType';
import IMediaEventsStreamPayload from '../../../../Solutions/Shared/Interfaces/IMediaEventsStreamPayload';
import ISolutionState            from '../../../../Solutions/Shared/Interfaces/ISolutionState';

const createTimeUpdateStream = (
    mediaEvents$: Observable<IMediaEventsStreamPayload>
): Observable<ISolutionState> =>
    mediaEvents$
        .pipe(
            filter(({type, state}) => type === SyntheticMediaEventType.TIME_UPDATE && !isNaN(state.maxTime)),
            distinctUntilChanged((
                {state: prevState},
                {state: nextState}
            ) => prevState.currentTime === nextState.currentTime && prevState.maxTime === nextState.maxTime),
            map(({state}) => state),
            share()
        );

export default createTimeUpdateStream;